import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { ModalContato } from "../Modal";
export function Slider() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel
      activeIndex={index}
      onSelect={handleSelect}
      style={{ height: "24rem", background: "#ffffff", color: "#464646" }}
      classaName="container-slider"
    >
      <Carousel.Item>
        <Carousel.Caption
          style={{ color: "#464646" }}
          className="banner-slider"
          id="um"
        >
          <h3 id="home">Deseja otimizar seu atendimento?</h3>
          <p className="subnome">
            Entre em contato para fazer um teste grátis.
          </p>
          <ModalContato />
          <p className="banner-p">
            Com chat bot você pode otimizar seu atendimento deixando um bot pré
              configurado conforme você deseja, 24hrs por dia de domingo a
            domingo, reduzindo seus custos, agilizar atendimento, passando
            credibilidade e aumentando suas vendas.
          </p>
        </Carousel.Caption>
        <div className="image-slider">
          <img
            className="d-block w-100"
            src="WhatsApp-Solutions.png"
            alt="Second slide"
          />
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <Carousel.Caption
          style={{ color: "#464646" }}
          className="banner-slider"
        >
          <h3>Deseja otimizar seu atendimento ?</h3>
          <p className="subnome">
            Entre em contato para fazer um teste grátis.
          </p>
          <ModalContato />
          <p className="banner-p">
            Com chat bot você pode otimizar seu atendimento deixando um bot pré
              configurado conforme você deseja, 24hrs por dia de domingo a
            domingo, reduzindo seus custos, agilizar atendimento, passando
            credibilidade e aumentando suas vendas.
          </p>
        </Carousel.Caption>
        <div className="image-slider">
          <img className="d-block2 w-100" src="hero.webp" alt="Second slide" />
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <Carousel.Caption
          style={{ color: "#464646" }}
          className="banner-slider"
          id="um"
        >
          <h3>Deseja otimizar seu atendimento ?</h3>
          <p className="subnome">
            Entre em contato para fazer um teste grátis.
          </p>
          <ModalContato />
          <p className="banner-p">
            Com chat bot você pode otimizar seu atendimento deixando um bot pré
              configurado conforme você deseja, 24hrs por dia de domingo a
            domingo, reduzindo seus custos, agilizar atendimento, passando
            credibilidade e aumentando suas vendas.
          </p>
        </Carousel.Caption>
        <div className="image-slider">
          <img
            className="d-block w-100"
            src="Chatbot-WhatsApp.webp"
            alt="Second slide"
          />
        </div>
      </Carousel.Item>
    </Carousel>
  );
}
